import React, {useEffect, useState} from 'react';
import './Header.css';
import {useNavigate} from "react-router-dom";
import {auth, database} from '../../../utils/firebase';
import {signOut} from "firebase/auth";
import {Alert, Button, Typography} from "@mui/joy";
import {onValue, ref} from "firebase/database";

const Header = () => {
    const navigate = useNavigate();
    const alertRef = ref(database, 'alerts');
    const [alertData, setAlertData] = useState({});
    const [alertIds, setAlertIds] = useState([]);


    useEffect(() => {
        onValue(alertRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setAlertData(data);
                setAlertIds(Object.keys(data));
            }
        });
    }, []);

    const handleNavigation = (url) => {
        if (url.startsWith('http')) {
            window.location.href = url;
        } else {
            navigate(url);
        }
    };

    const handleDashboardClick = () => {
        navigate('/app');
    };
    const handleLoginClick = () => {
        navigate('/auth/login');
    };
    const handleSignupClick = () => {
        navigate('/auth/signup');
    };

    const [isLoggedIn, setIsLoggedIn] = React.useState(false);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);

    return (
        <div>
            <div>
                {alertIds.map((id) => (
                    <Alert
                        color={alertData[id].severity}
                        variant={alertData[id].variant}
                        size={alertData[id].size}
                        sx={{ borderRadius: 0 }}
                        endDecorator={alertData[id].buttonUrl !== false &&
                            <Button onClick={() => handleNavigation(alertData[id].buttonUrl)}
                                    variant="contained"
                                    color="primary">{alertData[id].buttonText}</Button>
                    }
                    >
                        <Typography paddingLeft={"10px"} level={"body-" + alertData[id].size}>{alertData[id].content}</Typography>
                    </Alert>
                ))}
            </div>
            <header className="header light-gradient">
                <div className="header-left">
                    <img src="/cdn/logo.png" alt="Logo" style={{height:'60px', cursor: "pointer"}} onClick={() => navigate(`/`)} />
                    <nav className="header-nav">
                        <ul>
                            {/*<li><a href="/about">About</a></li>*/}
                            {/*<li><a href="/pricing">Pricing</a></li>*/}
                        </ul>
                    </nav>
                </div>
                <div className="header-right">
                    {!isLoggedIn? (
                        <div style={{display:'flex', flexDirection: 'row', gap:'10px'}}>
                            <Button className="button-gradient" size={"lg"} onClick={handleLoginClick}>Login</Button>
                            <Button className="button-gradient" size={"lg"} onClick={handleSignupClick}>Get Started</Button>
                        </div>
                    ) : (
                        <div style={{display:'flex', flexDirection: 'row', gap:'10px'}}>
                            <Button className="button-gradient" size={"lg"} onClick={handleDashboardClick}>Dashboard</Button>
                            <Button className="button-gradient" size={"lg"} onClick={() => signOut(auth).then(()=>{navigate('/')})}>Sign Out</Button>
                        </div>
                    )}
                </div>
            </header>
        </div>
    );
};

export default Header;